'use client'

// import { Database } from "@/lib/types";
import { createClientComponentClient } from "@supabase/auth-helpers-nextjs";

export default createClientComponentClient();